import { BRANDS, LOCALES } from 'project-constants';
import Joi from 'joi';

interface Config {
	brand: string;
	locale: string;
	apiUrl: string;
}

const SCHEMA = Joi.object<Config>({
	brand: Joi.string()
		.valid(...Object.values(BRANDS))
		.required(),
	locale: Joi.string()
		.valid(...Object.values(LOCALES))
		.required(),
	apiUrl: Joi.string().required(),
});

const BASE_CONFIG = Object.freeze({
	brand: process.env.REACT_APP_BRAND,
	locale: process.env.REACT_APP_LOCALE,
	apiUrl: process.env.REACT_APP_API_URL,
});

export const CONFIG = Joi.attempt(BASE_CONFIG, SCHEMA);
